module.exports = __webpack_public_path__ + "img/swiper.7e6f61f4.webp";